import React from 'react'
import { Scanner } from '@yudiel/react-qr-scanner'
import useViewModel from './ViewModel'
import Table from 'react-bootstrap/Table'
import { Badge, Button } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { KTSVG } from '../../../../_metronic/helpers'
import clsx from 'clsx'
import Switch from 'react-switch'
import PileExecutionAttachmentView from '../PileExecutionAttachment/View'
import PreboreSettingModal from '../Detail/Components/HoleList/PreboreSettingModal'
import ModeSelectionModal from './Components/ModeSelectionModal'
import Select from 'react-select'
import { formatPreboreValue } from 'Utils/prebore'

const ProjectPileExecutionView: React.FC = () => {
  const {
    isSubmitting,
    projectMachineOptions,
    projectState,
    inventorySelected,
    projectId,
    startScan,
    manualScanInput,
    scannedData,
    pileHole,
    isModeModalOpen,
    effectiveExecutionMode,
    hasCamera,
    isUseCamera,
    toggleUseCamera,
    showAddButtonAttachmentDrivedPile,
    handleScan,
    handleManualScan,
    handleRemoveScanned,
    handleInputCodeChange,
    handleCancelSelected,
    handlePileDriving,
    openModeSelectionModal,
    closeModeSelectionModal,
    handleSelectExecutionMode,
    handleSavePreboreOnly,
    handlePileClose,
    handleExecutedPileAttachment,
    onOpenproject,
    onCloseproject,
    holePreboreFormState,
    onChangeHolePreboreFormState,
    pileScanFormState,
    onChangePileScanFormState,
    holePrebore,
    openPreboreModal,
    setOpenPreboreModal,
    handleSavePrebore,
    isSavingPrebore,
  } = useViewModel()

  const mappingStatus: Record<string, string> = {
    received: 'พร้อมใช้งาน',
    'pile-driving': 'กำลังตอก',
    done: 'ตอกสำเร็จ',
  }

  return (
    <React.Fragment>
      <PileExecutionAttachmentView />

      <div className='row gy-5 mb-5'>
        <div className='col-12'>
          <div className='card'>
            <div className='card-header'>
              <div className='card-title'>
                {effectiveExecutionMode === 'prebore_only' ? 'Prebore' : 'Scan QR Code'}
              </div>
              <div className='card-toolbar'>
                {projectState === 'pending' && (
                  <button onClick={onOpenproject} className='btn btn-success me-2 mb-2'>
                    เปิดโครงการ
                  </button>
                )}
                {projectState === 'in-progress' && (
                  <button onClick={onCloseproject} className='btn btn-danger me-2 mb-2'>
                    ปิดโครงการ
                  </button>
                )}

                {pileHole?.status !== 'completed' && (
                  <button
                    className='btn btn-sm btn-primary me-2 mb-2'
                    onClick={openModeSelectionModal}>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr075.svg'
                      svgClassName='svg-icon-1x svg-primary'
                    />
                    <span>เริ่มตอกเสาเข็ม</span>
                  </button>
                )}

                <Link to={`/project/${projectId}/pile-executed-list`}>
                  <button className='btn btn-sm btn-primary mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr017.svg'
                      svgClassName='svg-icon-1 svg-primary'
                    />
                    <span>รายการหลุม</span>
                  </button>
                </Link>
              </div>
            </div>

            <div className='card-body'>
              {effectiveExecutionMode === 'drive' && startScan && (
                <div className='row'>
                  <div className='col-6'>
                    <label>
                      <span style={{ marginRight: 20 }}>ใช้งานกล้อง</span>
                      <Switch onChange={toggleUseCamera} checked={isUseCamera} />
                    </label>
                  </div>
                </div>
              )}
              {effectiveExecutionMode === 'drive' && startScan && hasCamera && isUseCamera && (
                <Scanner
                  // facingMode='environment'
                  // delay={1000}
                  onScan={handleScan}
                  constraints={{ facingMode: 'environment' }}
                />
              )}
                
              {effectiveExecutionMode === 'drive' && startScan && !isUseCamera && (
                <form
                  className='row'
                  onSubmit={(e: React.FormEvent) => {
                    e.preventDefault()
                    handleManualScan()
                  }}>
                  <div className='separator separator-dashed my-6'></div>
                  <div className='fs-6 fw-bolder mb-1'>ระบุรหัส Barcode</div>
                  <div className='col-xl-3'>
                    <Form.Control
                      type='text'
                      id='manualInput'
                      value={manualScanInput}
                      onChange={handleInputCodeChange}
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className='col d-flex mt-5 mt-lg-0'>
                    <Button disabled={isSubmitting} variant='primary' type='submit'>
                      <KTSVG
                        path='/media/icons/duotune/files/fil009.svg'
                        className='svg-icon-2x svg-primary'
                      />
                      ยืนยัน
                    </Button>
                  </div>
                </form>
              )}
              {effectiveExecutionMode === 'prebore_only' && !pileHole && (
                <div className='row'>
                  <div className='col-12 mb-3'>
                    <h4 className='mb-0'>Prebore</h4>
                  </div>
                  <div className='col-md-6 mb-4'>
                    <label className='form-label'>ความลึก (เมตร)</label>
                    <input
                      disabled={isSavingPrebore}
                      type='number'
                      className='form-control form-control-sm'
                      value={holePreboreFormState.preboreDepth ?? ''}
                      onChange={(e: any) =>
                        onChangeHolePreboreFormState('preboreDepth', e.target.value)
                      }
                    />
                  </div>
                  <div className='col-md-6 mb-4'>
                    <label className='form-label'>ขนาดสว่าน (ม.ม.)</label>
                    <input
                      disabled={isSavingPrebore}
                      type='number'
                      className='form-control form-control-sm'
                      value={holePreboreFormState.preboreDrillSize ?? ''}
                      onChange={(e: any) =>
                        onChangeHolePreboreFormState('preboreDrillSize', e.target.value)
                      }
                    />
                  </div>
                  <div className='col-md-4 mb-4'>
                    <label className='form-label'>Pile No.</label>
                    <input
                      disabled={isSavingPrebore}
                      type='text'
                      className='form-control form-control-sm'
                      value={holePreboreFormState.pileNo ?? ''}
                      onChange={(e: any) =>
                        onChangeHolePreboreFormState('pileNo', e.target.value)
                      }
                    />
                  </div>
                  <div className='col-md-4 mb-4'>
                    <label className='form-label'>Grid Line</label>
                    <input
                      disabled={isSavingPrebore}
                      type='text'
                      className='form-control form-control-sm'
                      value={holePreboreFormState.gridLine ?? ''}
                      onChange={(e: any) =>
                        onChangeHolePreboreFormState('gridLine', e.target.value)
                      }
                    />
                  </div>
                  <div className='col-md-4 mb-4'>
                    <label className='form-label'>ชื่อผังทำงาน</label>
                    <input
                      disabled={isSavingPrebore}
                      type='text'
                      className='form-control form-control-sm'
                      value={holePreboreFormState.location ?? ''}
                      onChange={(e: any) =>
                        onChangeHolePreboreFormState('location', e.target.value)
                      }
                    />
                  </div>
                  <div className='col-12 text-end'>
                    <button
                      type='button'
                      className='btn btn-primary'
                      disabled={isSavingPrebore}
                      onClick={handleSavePreboreOnly}>
                      {isSavingPrebore ? 'กำลังบันทึก...' : 'บันทึก prebore'}
                    </button>
                  </div>
                </div>
              )}
              {/* <p>{data}</p> */}
              {effectiveExecutionMode === 'drive' && inventorySelected && (
                <Table striped bordered hover>
                  <tbody>
                    <tr>
                      <td>ชื่อเสา</td>
                      <td>
                        <p>{inventorySelected.pileTitle}</p>
                        <p>{inventorySelected.pileCode}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>สถานะ</td>
                      <td>
                        <Badge
                          bg={inventorySelected.usageStatus === 'done' ? 'success' : 'primary'}>
                          {mappingStatus[inventorySelected.usageStatus] ??
                            inventorySelected.usageStatus}
                        </Badge>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2} className='fw-bold bg-light'>
                        Prebore (หลุม)
                      </td>
                    </tr>
                    <tr>
                      <td>ความลึก (เมตร)</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='number'
                          className='form-control form-control-sm'
                          value={holePreboreFormState.preboreDepth ?? ''}
                          onChange={(e: any) =>
                            onChangeHolePreboreFormState('preboreDepth', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>ขนาดสว่าน (ม.ม.)</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='number'
                          className='form-control form-control-sm'
                          value={holePreboreFormState.preboreDrillSize ?? ''}
                          onChange={(e: any) =>
                            onChangeHolePreboreFormState('preboreDrillSize', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2} className='fw-bold bg-light'>
                        ข้อมูลเสาที่สแกน
                      </td>
                    </tr>
                    <tr>
                      <td>ตอกโดยเครื่องจักร</td>
                      <td>
                        <Select
                          isDisabled={isSubmitting}
                          id='projectMachineId'
                          options={projectMachineOptions}
                          value={
                            projectMachineOptions.find(
                              o => o.value === pileScanFormState.projectMachineId
                            ) ?? null
                          }
                          onChange={(selectedOption: any) => {
                            onChangePileScanFormState('projectMachineId', selectedOption?.value)
                          }}
                          styles={{
                            control: (provided: any) => ({
                              ...provided,
                              minHeight: 0,
                              fontSize: '0.95rem',
                              border: '1px solid #e1e3ea',
                            }),
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Pile No.</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='text'
                          className='form-control form-control-sm'
                          value={pileScanFormState.pileNo ?? ''}
                          onChange={(e: any) =>
                            onChangePileScanFormState('pileNo', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Grid Line</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='text'
                          className='form-control form-control-sm'
                          value={pileScanFormState.gridLine ?? ''}
                          onChange={(e: any) =>
                            onChangePileScanFormState('gridLine', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>ชื่อผังทำงาน</td>
                      <td>
                        <input
                          disabled={isSubmitting}
                          type='text'
                          className='form-control form-control-sm'
                          value={pileScanFormState.location ?? ''}
                          onChange={(e: any) =>
                            onChangePileScanFormState('location', e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              )}
            </div>
          </div>
        </div>

        {/* Confirm Exec pile action */}
        {effectiveExecutionMode === 'drive' && inventorySelected && (
          <div className='col-12'>
            <div className='text-center my-3 d-flex justify-content-between'>
              <Button
                disabled={isSubmitting}
                variant='danger'
                className='mx-3'
                onClick={() => {
                  handleCancelSelected()
                }}>
                ยกเลิก
              </Button>
              {inventorySelected.usageStatus === 'received' && (
                <Button
                  disabled={isSubmitting}
                  variant='success'
                  className='mx-3'
                  onClick={() => {
                    handlePileDriving()
                  }}>
                  ยืนยันการตอก
                </Button>
              )}
            </div>
          </div>
        )}
        {/* END Confirm Exec pile action */}

        {pileHole && (
          <div className='col-12'>
            <div className='card'>
              <div className='card-body'>
                <h3>
                  หลุมที่ {pileHole.seq} {pileHole.status}
                </h3>

                <div className='mb-5 d-flex flex-column gap-2'>
                  <div className='fs-6 fw-semibold'>
                    ความลึก (เมตร): {formatPreboreValue(holePrebore.preboreDepth)}
                  </div>
                  <div className='fs-6 fw-semibold'>
                    ขนาดสว่าน (ม.ม.): {formatPreboreValue(holePrebore.preboreDrillSize)}
                  </div>
                  {holePrebore.pileNo && (
                    <div className='fs-6 fw-semibold'>Pile No.: {holePrebore.pileNo}</div>
                  )}
                  {holePrebore.gridLine && (
                    <div className='fs-6 fw-semibold'>Grid Line: {holePrebore.gridLine}</div>
                  )}
                  {holePrebore.location && (
                    <div className='fs-6 fw-semibold'>ชื่อผังทำงาน: {holePrebore.location}</div>
                  )}
                  {effectiveExecutionMode !== 'prebore_only' && (
                    <button
                      type='button'
                      className='btn btn-sm btn-primary'
                      onClick={() => setOpenPreboreModal(true)}>
                      ตั้งค่า prebore
                    </button>
                  )}
                </div>

                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                    {/* begin::Table head */}
                    <thead>
                      <tr>
                        <th className='p-0 w-50px'></th>
                        <th className='p-0 min-w-150px'></th>

                        <th className='p-0 min-w-125px'></th>
                        <th className='p-0 min-w-40px'></th>
                      </tr>
                    </thead>
                    {/* end::Table head */}
                    {/* begin::Table body */}
                    <tbody>
                      {pileHole.itemInventory.map((item: any, index: number) => (
                        <tr key={index + 'pileHole'}>
                          <td>
                            <div className='symbol symbol-50px me-2'>
                              <span className='symbol-label'>
                                <KTSVG
                                  path='/media/icons/duotune/general/gen002.svg'
                                  className='svg-icon-1 svg-icon-2hx'
                                />
                              </span>
                            </div>
                          </td>
                          <td>
                            <span className='text-gray-900 fw-bold text-hover-primary mb-1 fs-6'>
                              ({index + 1}) {item.pileCode}
                            </span>
                            <span className='fw-semibold d-block fs-7'>{item.pileTitle}</span>
                            <span className='text-muted fw-semibold d-block fs-7'>
                              เครื่องจักรที่ใช้ตอก:{' '}
                              {projectMachineOptions.find(pm => pm.value === item.projectMachineId)
                                ?.label ?? '-'}
                            </span>
                            {item.pileNo && (
                              <span className='text-muted fw-semibold d-block fs-7'>
                                Pile No.: {item.pileNo}
                              </span>
                            )}
                            {item.gridLine && (
                              <span className='text-muted fw-semibold d-block fs-7'>
                                Grid Line: {item.gridLine}
                              </span>
                            )}
                            {item.location && (
                              <span className='text-muted fw-semibold d-block fs-7'>
                                ชื่อผังทำงาน: {item.location}
                              </span>
                            )}

                            <button
                              className={clsx('btn btn-primary btn-sm mt-3', {
                                'd-none': !showAddButtonAttachmentDrivedPile(index),
                              })}
                              onClick={() => handleExecutedPileAttachment(index)}>
                              <KTSVG
                                path='/media/icons/duotune/general/gen005.svg'
                                className='svg-icon-1x svg-primary'
                              />
                              แนบรูปภาพรอยเชื่อมของเสา ({index}) + ({index + 1})
                            </button>
                          </td>

                          <td className='text-end'>
                            <span className='text-muted fw-semibold'>
                              {moment(item.usedAt).format('YYYY-MM-DD HH:mm')}
                            </span>
                          </td>
                          <td className='text-end'>
                            <a
                              onClick={() => {
                                handleRemoveScanned(item.inventoryCode, item.pileCode)
                              }}
                              href='#'
                              className=''>
                              <KTSVG
                                path='/media/icons/duotune/general/gen040.svg'
                                className='svg-icon-1 svg-icon-2hx svg-icon-danger'
                              />
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    {/* end::Table body */}
                  </table>
                  {/* end::Table */}
                  {pileHole.status === 'in-progress' && (
                    <div className='text-center'>
                      <a
                        onClick={() => {
                          handlePileClose()
                        }}
                        className='btn btn-primary'>
                        <span className='svg-icon svg-icon-1'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen003.svg'
                            className='svg-icon-1  svg-icon-primary'
                          />
                        </span>
                        ปิดหลุม
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='text-center'>
          <Link to={'/project/' + projectId + '/overview'}>
            <Button variant='info'>กลับไปโครงการ</Button>
          </Link>
        </div>
      </div>

      <PreboreSettingModal
        isOpen={openPreboreModal}
        handleClose={() => setOpenPreboreModal(false)}
        initialDepth={holePreboreFormState.preboreDepth ?? ''}
        initialDrillSize={holePreboreFormState.preboreDrillSize ?? ''}
        initialPileNo={holePreboreFormState.pileNo ?? ''}
        initialGridLine={holePreboreFormState.gridLine ?? ''}
        initialLocation={holePreboreFormState.location ?? ''}
        isSaving={isSavingPrebore}
        onSave={handleSavePrebore}
      />
      <ModeSelectionModal
        isOpen={isModeModalOpen}
        isSubmitting={isSavingPrebore}
        onClose={closeModeSelectionModal}
        onSelectMode={handleSelectExecutionMode}
      />
    </React.Fragment>
  )
}

export default ProjectPileExecutionView
